import { render } from "./TransferTemplate.vue?vue&type=template&id=0b78f109"
import script from "./TransferTemplate.vue?vue&type=script&lang=js"
export * from "./TransferTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__